






























































import DataOutput from './DataOutput.vue';
import TextHeader from './TextHeader.vue';
import Vue, { PropType } from 'vue';
import { Cpu } from '@/emulator/EmulatorInfo';

export default Vue.extend({
    name: 'device-interrupts',
    components: { DataOutput, TextHeader },
    props: {
        cpu: { type: Object as PropType<Cpu>, required: true },
    },
});
